import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import {NotFound} from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const DivisionListView = Loadable({
    loader: () => import("~/views/admin/division/DivisionListView"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/`} component={DivisionListView} />
        <Route component={NotFound} />
    </Switch>
);